export const TRIAL_ATTEMPT_MAX_AREA_KM = 5;
